import { TableCell } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { SetterOrUpdater, useSetRecoilState } from "recoil";

import {
  canResolveIfExists,
  IExtendableDto,
  Log,
  onActivateKeyDown,
  passengersListBookingAtom,
  updateListEntity,
  useDrawers,
} from "@ryde/shared";
import { blueMui } from "@ryde/theme";

interface IRejectedBookingPassengerTableCellProps extends PropsWithChildren {
  passengerId?: number;
}

export const RejectedBookingPassengerTableCell: FC<
  IRejectedBookingPassengerTableCellProps
> = ({ passengerId, children }) => {
  const { openEditFormDrawer } = useDrawers();
  const setPassengersListBookingAtom = useSetRecoilState(
    passengersListBookingAtom,
  );
  const { t } = useTranslation();

  const onPassengerEdit = async (): Promise<void> => {
    if (!passengerId) {
      Log.warn(t("No passenger id", { passengerId })); // TODO: fix translation key
      return;
    }

    const simpleResult = await openEditFormDrawer({
      entity: "passenger",
      id: passengerId,
      canResolve: canResolveIfExists,
    });

    if (!simpleResult.success) {
      Log.warn(t("errors.passengerDidntUpdate", { passengerId }));
      return;
    }

    updateListEntity(
      setPassengersListBookingAtom as unknown as SetterOrUpdater<
        IExtendableDto[]
      >,
      simpleResult.data as IExtendableDto,
    );
  };

  return (
    <TableCell>
      <div
        className="cell_simple pointer"
        role="button"
        tabIndex={0}
        onClick={onPassengerEdit}
        onKeyDown={onActivateKeyDown(onPassengerEdit)}
        color={blueMui.A400}
      >
        {children}
      </div>
    </TableCell>
  );
};
